import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import Parameter from "./Parameter.graphql";
import { taxonomy } from "../../api";

export default function useParameter(id: string) {
    return useQuery(
        gql(Parameter),
        {
            client: taxonomy,
            skip: id === undefined,
            variables: {
                id,
            },
        },
    );
}
